/** All built-in and custom scalars, mapped to their actual values */

export let BeaconProximity;
(function (BeaconProximity) {
  BeaconProximity["Far"] = "far";
  BeaconProximity["Immediate"] = "immediate";
  BeaconProximity["Near"] = "near";
  BeaconProximity["Unknown"] = "unknown";
})(BeaconProximity || (BeaconProximity = {}));
export let BluetoothStatusType;
(function (BluetoothStatusType) {
  BluetoothStatusType["Allowed"] = "ALLOWED";
  BluetoothStatusType["Denied"] = "DENIED";
  BluetoothStatusType["Unknown"] = "UNKNOWN";
})(BluetoothStatusType || (BluetoothStatusType = {}));
export let ChargingStatusType;
(function (ChargingStatusType) {
  ChargingStatusType["Charging"] = "CHARGING";
  ChargingStatusType["Full"] = "FULL";
  ChargingStatusType["Unknown"] = "UNKNOWN";
  ChargingStatusType["Unplugged"] = "UNPLUGGED";
})(ChargingStatusType || (ChargingStatusType = {}));
export let ErrorDetail;
(function (ErrorDetail) {
  ErrorDetail["DeadlineExceeded"] = "DEADLINE_EXCEEDED";
  ErrorDetail["EnhanceYourCalm"] = "ENHANCE_YOUR_CALM";
  ErrorDetail["FieldNotFound"] = "FIELD_NOT_FOUND";
  ErrorDetail["InvalidArgument"] = "INVALID_ARGUMENT";
  ErrorDetail["InvalidCursor"] = "INVALID_CURSOR";
  ErrorDetail["MissingResource"] = "MISSING_RESOURCE";
  ErrorDetail["ServiceError"] = "SERVICE_ERROR";
  ErrorDetail["TcpFailure"] = "TCP_FAILURE";
  ErrorDetail["ThrottledConcurrency"] = "THROTTLED_CONCURRENCY";
  ErrorDetail["ThrottledCpu"] = "THROTTLED_CPU";
  ErrorDetail["Unimplemented"] = "UNIMPLEMENTED";
  ErrorDetail["Unknown"] = "UNKNOWN";
})(ErrorDetail || (ErrorDetail = {}));
export let ErrorType;
(function (ErrorType) {
  ErrorType["BadRequest"] = "BAD_REQUEST";
  ErrorType["FailedPrecondition"] = "FAILED_PRECONDITION";
  ErrorType["Internal"] = "INTERNAL";
  ErrorType["NotFound"] = "NOT_FOUND";
  ErrorType["PermissionDenied"] = "PERMISSION_DENIED";
  ErrorType["Unauthenticated"] = "UNAUTHENTICATED";
  ErrorType["Unavailable"] = "UNAVAILABLE";
  ErrorType["Unknown"] = "UNKNOWN";
})(ErrorType || (ErrorType = {}));
/** Only one of the operations will apply. If none is set, it'll be ignored */
export let JackStatusType;
(function (JackStatusType) {
  JackStatusType["Plugged"] = "PLUGGED";
  JackStatusType["Unknown"] = "UNKNOWN";
  JackStatusType["Unplugged"] = "UNPLUGGED";
})(JackStatusType || (JackStatusType = {}));
export let LightedCaseType;
(function (LightedCaseType) {
  LightedCaseType["Generic"] = "GENERIC";
  LightedCaseType["None"] = "NONE";
  LightedCaseType["VisualTarget"] = "VISUAL_TARGET";
})(LightedCaseType || (LightedCaseType = {}));
export let OauthProvider;
(function (OauthProvider) {
  OauthProvider["Google"] = "GOOGLE";
  OauthProvider["MicrosoftService"] = "MICROSOFT_SERVICE";
  OauthProvider["MicrosoftUser"] = "MICROSOFT_USER";
})(OauthProvider || (OauthProvider = {}));
export let RoomAvailability;
(function (RoomAvailability) {
  RoomAvailability["Available"] = "AVAILABLE";
  RoomAvailability["Occupied"] = "OCCUPIED";
  RoomAvailability["Pending"] = "PENDING";
})(RoomAvailability || (RoomAvailability = {}));
export let RoomSyncStatus;
(function (RoomSyncStatus) {
  RoomSyncStatus["SyncCompleted"] = "SYNC_COMPLETED";
  RoomSyncStatus["SyncNotStarted"] = "SYNC_NOT_STARTED";
  RoomSyncStatus["SyncStarted"] = "SYNC_STARTED";
})(RoomSyncStatus || (RoomSyncStatus = {}));
export let RoomsOrderBy;
(function (RoomsOrderBy) {
  RoomsOrderBy["BuildingName"] = "BUILDING_NAME";
  RoomsOrderBy["DisplayName"] = "DISPLAY_NAME";
  RoomsOrderBy["FloorName"] = "FLOOR_NAME";
  RoomsOrderBy["LocationName"] = "LOCATION_NAME";
})(RoomsOrderBy || (RoomsOrderBy = {}));
export let SortDirection;
(function (SortDirection) {
  SortDirection["Asc"] = "ASC";
  SortDirection["Desc"] = "DESC";
})(SortDirection || (SortDirection = {}));
/** Only one of the operations will apply. If none is set, it'll be ignored */
export let TimeFormat;
(function (TimeFormat) {
  TimeFormat["Military"] = "MILITARY";
  TimeFormat["Standard"] = "STANDARD";
})(TimeFormat || (TimeFormat = {}));